module.exports = __webpack_public_path__ + "static/media/SMS_Number_Icon.a987e886.svg";